import React from 'react';

import SavedSearch from '@buyside/components/presentation/SavedSearch/savedSearch';

import { useFundProfileIndexSavedSearchQuery } from '@interfaces/graphql-typings';

const FundProfileSavedSearchContainer: React.FC = () => {
  const { data, loading } = useFundProfileIndexSavedSearchQuery();

  return (
    <SavedSearch
      loading={loading}
      savedSearchList={data?.fundProfilesSavedSearchList}
      searchType="FundProfile"
    />
  );
};

export default FundProfileSavedSearchContainer;
